import { useEffect, lazy } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./components/LanguageContext";
import NotFound from "./components/NotFound";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ParticlesComponent from "./components/Particles";
const BackToTop = lazy(() => import("./components/BackToTop"));
const Progress = lazy(() => import("./components/Progress"));
const Footer = lazy(() => import("./components/Footer"));
const ChiSono = lazy(() => import("./components/ChiSono"));
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const ContactForm = lazy(() => import("./components/ContactForm"));
const Collaborations = lazy(() => import("./components/Collaborations"));
const Projects = lazy(() => import("./components/Projects"));

gsap.registerPlugin(ScrollTrigger);

function AppContent() {
  useEffect(() => {
    let ctx = gsap.context(() => {
      const elements = gsap.utils.toArray(".animate-on-scroll");
      elements.forEach((element) => {
        gsap.fromTo(
          element,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: element,
              start: "top 80%",
              toggleActions: "play none none reverse",
              once: true,
            },
          },
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div style={{ position: "relative", overflow: "hidden" }}>
            <ParticlesComponent id="particles" />
            <div style={{ position: "relative", zIndex: 1 }}>
              <Navbar />
              <main className="container mt-5">
                <section id="home">
                  <HeroSection />
                </section>
              </main>
              <ChiSono />
              <Progress />
              <Collaborations />
              <Projects />
              <ContactForm />
            </div>
            <BackToTop />
            <Footer />
          </div>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <div style={{ position: "relative", overflow: "hidden" }}>
            <ParticlesComponent id="particles" />
            <PrivacyPolicy />
          </div>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}
